import { createContext, useContext } from 'react'

/**
 * When true, the app is in focus/reading mode.
 * Child components (PageInfoRow, SoundPlayer, etc.) should hide themselves.
 */
export const FocusModeContext = createContext(false)

export const useFocusModeContext = () => useContext(FocusModeContext)
